const siteDateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'long',
  day: '2-digit',
  year: 'numeric'
});

export default function SiteDateReadout({ className = '' }) {
  return (
    <p className={`text-sm text-muted-foreground ${className}`}>
      Current site date: {siteDateFormatter.format(new Date())}
    </p>
  );
}
